import { capitalize } from '@/libs/strings';

export function activateAction(url, entity) {
  return {
    "title": 'Are you sure?',
    "message": "Do you really want to activate this " + entity,
    "url": "/" + url + "/activate",
    "icon": "humbleicons:switch-on",
    "action": 'activate',
    "confirm": false,
    "text": "Activate",
    "button": "Confirm",
  };
}

export function deactivateAction(url, entity) {
  return {
    "title": 'Are you sure?',
    "message": "Do you really want to deactivate this " + entity,
    "url": "/" + url + "/deactivate",
    "icon": "humbleicons:switch-off",
    "action": 'deactivate',
    "confirm": false,
    "text": "Deactivate",
    "button": "Confirm",
  };
}

export function deleteAction(url, entity) {
  return {
    "title": 'Are you sure?',
    "message": "Do you really want to delete this " + entity + "? This is irreversible!",
    "url": "/" + url + "/delete",
    "icon": "humbleicons:trash",
    "action": 'delete',
    "confirm": "DELETE",
    "text": "Delete",
    "button": "Confirm",
  };
}

export const action = (action, url, entity, icon = '') => {
  return {
    "title": 'Are you sure?',
    "message": "Do you really want to " + action + " this " + entity + "? This is irreversible!",
    "url": "/" + url + "/" + action,
    "icon": icon,
    "action": action,
    "confirm": action.toUpperCase(),
    "text": capitalize(action),
    "button": "Confirm",
  };
}
